<template>
  <div>
    <el-form :model="searchForm" class="search-form" inline label-width="70px">
      <el-form-item :label="$t('common.singerName')">
        <el-input
          v-model="searchForm.singerName"
          :placeholder="$t('common.singerNamePlaceholder')"
          @keypress.native.enter="handleSearch"
          class="form-comp"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('album.albumName')">
        <el-input
          v-model="searchForm.albumName"
          :placeholder="$t('album.albumNamePlaceholder')"
          @keypress.native.enter="handleSearch"
          class="form-comp"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="!isCompany" :label="$t('modify.applyUser')">
        <el-input
          v-model="searchForm.companyName"
          :placeholder="$t('modify.applyUserPlaceholder')"
          @keypress.native.enter="handleSearch"
          class="form-comp"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('modify.insertTime')">
        <el-date-picker
          v-model="searchForm.insertTime"
          type="date"
          class="form-comp"
          clearable
          @change="handleSearch"
          value-format="yyyy-MM-dd"
          :placeholder="$t('modify.insertTimePlaceholder')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('modify.auditTime')">
        <el-date-picker
          v-model="searchForm.modifyTime"
          @change="handleSearch"
          type="date"
          class="form-comp"
          value-format="yyyy-MM-dd"
          clearable
          :placeholder="$t('modify.auditTimePlaceholder')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('modify.status')">
        <el-select v-model="searchForm.reviewStatus" clearable class="form-comp" @change="handleSearch">
          <el-option v-for="(name, key) in songAlbumReviewStatusMap" :key="key" :label="$t(`modify.songAlbumStatusMap[${key}]`)" :value="+key">
            <span :class="statusClassMap[key]">{{ $t(`modify.songAlbumStatusMap[${key}]`) }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('modify.auditor')">
        <el-input v-model="searchForm.reviewUserName" class="form-comp" :placeholder="$t('modify.auditor')"></el-input>
      </el-form-item>
      <el-button type="primary" :loading="searching" @click="handleSearch">
        {{ $t('common.search') }}
      </el-button>
    </el-form>

    <el-card>
      <div>
        <template v-if="isCompany">
          <el-button type="info" @click="handleBatchEditApply(1)">
            {{ $t('common.cancel') }}
          </el-button>
        </template>
        <template v-else>
          <el-button v-if="isBussiness || isLegal || isAdmin" type="success" @click="handleBatchReview(2)">批量通过</el-button>
          <el-button v-if="isBussiness || isLegal || isAdmin" type="danger" @click="handleBatchReview(3)">批量拒绝</el-button>
          <el-button v-if="isBussiness" type="warning" @click="handleBatchTrans">批量转移</el-button>
        </template>
      </div>
      <el-table
        v-loading="searching"
        ref="table"
        :data="tableData"
        class="tight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :selectable="rowSelectable" width="30"></el-table-column>
        <el-table-column v-if="!isCompany" label="提交用户（厂牌名）" prop="companyName"></el-table-column>
        <el-table-column v-if="!isCompany" label="公司类型" prop="cpCompanyType" v-slot="{ row }">
          {{ cpTypeMap[row.cpCompanyType] }}
        </el-table-column>
        <el-table-column label="专辑名" prop="albumName" v-slot="{ row }">
          <template>
            <router-link :to="{name: 'albumEdit', query: {id: row.albumId}}" target="_blank">{{ row.albumName }}</router-link>
          </template>
        </el-table-column>
        <el-table-column label="艺人名" v-slot="{ row }">
          {{ row.singerNameList.join(',') }}
        </el-table-column>
        <el-table-column label="修改字段" width="110" v-slot="{ row }">
          {{ getFieldName(row) }}
        </el-table-column>
        <el-table-column :label="$t('modify.before')" v-slot="{ row }">
          <template v-if="mediaCompConfig[row.table]">
            <media-item :data="row.oldVal" :media-type="mediaCompConfig[row.table]"></media-item>
          </template>
          <template v-else>
            {{ row.column !== 'newRecord' ? getShowValue(row, 'oldVal') : '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('modify.after')" v-slot="{ row }">
          <template v-if="mediaCompConfig[row.table]">
            <media-item :data="row.newVal" :media-type="mediaCompConfig[row.table]"></media-item>
          </template>
          <template v-else>
            <template v-if="row.column !== 'newRecord'">
              {{ getShowValue(row, 'newVal') }}
            </template>
            <template v-else>
              <el-popover
                placement="left"
                width="400"
                trigger="hover"
              >
                <el-form label-width="150px" class="search-form">
                  <template v-for="key in Object.keys(row.newVal)">
                    <template v-if="fieldExist(row, key)">
                      <el-form-item :key="key" :label="`${fieldNameMap[row.table][key]}：`">
                        {{ getFieldValue(key, row.newVal[key]) }}
                      </el-form-item>
                    </template>
                  </template>
                </el-form>
                <a slot="reference" href="javascript:;">查 看</a>
              </el-popover>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('modify.status')" width="60" v-slot="{ row }">
          <span :class="statusClassMap[row.reviewStatus]">{{ $t(`modify.songAlbumStatusMap[${row.reviewStatus}]`) }}</span>
        </el-table-column>
        <el-table-column label="相关证明" width="80" v-slot="{ row }">
          <el-button type="text" @click="handleShowLicense(row)">授权文件</el-button>
        </el-table-column>
        <el-table-column label="申请提交时间" width="100" prop="insertTime"></el-table-column>
        <el-table-column label="审核时间" width="80" v-slot="{ row }">
          {{ showModifyTimeStatusCodes.includes(row.reviewStatus) ? row.modifyTime : '-' }}
        </el-table-column>
        <el-table-column label="操作" :width="operateWidth()" header-align="center" v-slot="{ row }">
          <template v-if="showActionStatusCodes.includes(row.reviewStatus)">
            <template v-if="isCompany">
              <el-button type="info" @click="handleEditApply(row, 1)">{{ $t('common.cancel') }}</el-button>
            </template>
            <template v-else>
              <el-button v-if="canApply(row)" type="success" @click="handleReview(row, 2)">通过</el-button>
              <el-button v-if="canApply(row)" type="danger" @click="handleReview(row, 3)">拒绝</el-button>
              <el-button
                v-if="isBussiness && (row.reviewStatus === 0 || row.reviewStatus === 7)"
                type="warning"
                style="margin-left: 0;margin-top: 4px;"
                @click="handleTrans(row)"
              >
                转移
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSearch"
        @current-change="fetchData"
        :page-sizes="[10, 50, 100]"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
      <el-dialog
        v-if="showLicense"
        title="查看授权文件"
        :close-on-click-modal="false"
        :visible.sync="showLicense"
        @close="handleClose"
      >
        <el-table :data="licenseList">
          <el-table-column label="文件" v-slot="{ row }">
            <a :href="$toProtocolRelative(row.url)" target="_blank">{{ row.fileName }}</a>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import albumService from '@/api/album.js'
import { reviewStatusMap, SongAlbumReviewStatusEnum, CP_TYPE, fieldNameMap, copyrightValueDictMap } from './const.js'
import MediaItem from './components/MediaItem.vue'
import { safeJsonParse } from '@/utils/objUtil'

const freeze = Object.freeze
const stringType = freeze([
  'originCompanyName',
  'copyrightFrom',
  'copyrightTo',
  'cpPercent',
  'firstPublicTime',
  'albumName',
  'displayCompanyName',
  'publicTime',
  'albumDesc'
])
const arrayType = freeze(['copyrightArea'])
const dictType = freeze(['isOnly', 'canAuth', 'isAgent', 'cpSource', 'isOverseaOnly', 'paymentMode', 'canCover',
  'canLegalRights', 'contractType', 'licenseValid'])
const mediaCompConfig = {
  albumSingerList: 'singer',
  albumPhotoList: 'picture'
}
const mediaTableList = Object.keys(mediaCompConfig)

function safeGet(data, key) {
  return Array.isArray(data) ? data[0][key] : data[key]
}

export default {
  name: 'ApplyModifyAlbum',
  components: {
    MediaItem
  },
  data() {
    return {
      reviewStatusMap,
      SongAlbumReviewStatusEnum,
      songAlbumReviewStatusMap: SongAlbumReviewStatusEnum.codeNameMap,
      fieldNameMap,
      stringType,
      arrayType,
      dictType,
      cpTypeMap: CP_TYPE.codeNameMap,
      mediaCompConfig,
      mediaTableList,

      searchForm: {
        singerName: '',
        albumName: '',
        companyName: '',
        reviewStatus: '',
        insertTime: '',
        modifyTime: '',
        reviewUserName: '',
      },
      searching: false,
      showLicense: false,
      tableData: [],
      selection: [],
      licenseList: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isCompany',
      'isBussiness',
      'isEditor',
      'isLegal',
      'userInfo'
    ]),
    statusClassMap() {
      return {
        1: 'desc-word',
        2: 'success-word',
        3: 'danger-word',
        9: 'danger-word'
      }
    },
    showModifyTimeStatusCodes() {
      return [
        SongAlbumReviewStatusEnum.APPROVED.code,
        SongAlbumReviewStatusEnum.REJECTED.code,
        SongAlbumReviewStatusEnum.AUTO_APPROVED.code,
        SongAlbumReviewStatusEnum.INVALID_ARTIST_LINK_REJECTED.code
      ]
    },
    showActionStatusCodes() {
      return [
        SongAlbumReviewStatusEnum.UNREVIEWED.code,
        SongAlbumReviewStatusEnum.REVIEWING.code,
        SongAlbumReviewStatusEnum.AWAIT_HUMAN_REVIEW.code
      ]
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    canApply(row) {
      const { isBussiness, isLegal, isAdmin } = this

      // 商务能审核状态 0和7 的，法务能审核状态 4（审核中）的
      const isBusinessAllowed = isBussiness && (
        row.reviewStatus === SongAlbumReviewStatusEnum.UNREVIEWED.code ||
        row.reviewStatus === SongAlbumReviewStatusEnum.AWAIT_HUMAN_REVIEW.code
      )
      const isLegalAllowed = isLegal &&
        row.reviewStatus === SongAlbumReviewStatusEnum.REVIEWING.code
      return isBusinessAllowed || isLegalAllowed || isAdmin
    },
    operateWidth() {
      const { isBussiness, isLegal, isAdmin } = this
      if (isBussiness || isLegal || isAdmin) {
        return 120
      }

      return 80
    },
    rowSelectable(row, index) {
      const { isBussiness, isLegal } = this
      const { reviewStatus } = row

      if ([
        SongAlbumReviewStatusEnum.CANCELLED.code,
        SongAlbumReviewStatusEnum.APPROVED.code,
        SongAlbumReviewStatusEnum.REJECTED.code,
        SongAlbumReviewStatusEnum.AUTO_APPROVED.code,
        SongAlbumReviewStatusEnum.INVALID_ARTIST_LINK_REJECTED.code
      ].includes(reviewStatus)) {
        return false
      }
      if (isBussiness) {
        return reviewStatus === SongAlbumReviewStatusEnum.UNREVIEWED.code ||
              reviewStatus === SongAlbumReviewStatusEnum.AWAIT_HUMAN_REVIEW.code
      }
      if (isLegal) {
        return reviewStatus === SongAlbumReviewStatusEnum.REVIEWING.code
      }
      return true
    },
    async fetchData() {
      const { pagination, searchForm } = this.$data
      const searchData = {
        page: pagination.current - 1,
        num: pagination.size,
        ...searchForm
      }

      this.searching = true
      try {
        const resp = await albumService.queryModifyAlbum(searchData)
        this.pagination.total = resp.total
        this.tableData = resp.list.map(item => {
          if (['newRecord', 'modifyRecord', 'rmRecord'].includes(item.column)) {
            item.newVal = safeJsonParse(item.newVal)
            item.oldVal = safeJsonParse(item.oldVal)
          }

          // 处理封面
          if (item.table === 'albumPhotoList') {
            item.newVal = safeGet(item.newVal, 'photoUrl') ?? ''
            item.oldVal = safeGet(item.oldVal, 'photoUrl') ?? ''
          }

          return item
        })
      } catch (error) {
        console.error(error)
        this.$message({
          type: 'error',
          message: `获取字段修改记录异常(${error.message})`
        })
      }
      this.searching = false
    },
    /**
     * @return {boolean}
     */
    fieldExist(row, key) {
      return !!(fieldNameMap[row.table] && fieldNameMap[row.table][key])
    },

    getShowValue(rowObj, oldOrNew) {
      const { column } = rowObj
      const value = rowObj[oldOrNew]

      return this.getFieldValue(column, value)
    },
    getFieldValue(column, value) {
      if (stringType.includes(column)) {
        return value
      }

      if (arrayType.includes(column)) {
        const valueList = value.split(',')
        return valueList.map(item => copyrightValueDictMap[column][item]).join(', ')
      }

      if (dictType.includes(column)) {
        return copyrightValueDictMap[column][value]
      }

      if (column === 'originCpCompany') {
        return value.companyName
      }

      return ''
    },

    handleSearch() {
      this.pagination.current = 1

      this.fetchData()
    },
    handleClose() {
      this.showLicense = false
    },

    handleSelectionChange(selection) {
      this.selection = selection
    },

    /**
     * @param {object} rowObj
     */
    getFieldName(rowObj) {
      return fieldNameMap[rowObj.table][rowObj.column]
    },

    handleShowLicense(row) {
      this.licenseList = row.albumLicenseList
      this.showLicense = true
    },

    async handleBatchTrans() {
      const { selection } = this
      if (selection.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请选择至少一条流水'
        })
      }
      this.transfer(selection.map(item => item.id), 3)
    },

    async handleBatchEditApply(reviewStatus) {
      const { selection } = this
      if (selection.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请选择至少一条流水'
        })
      }

      const result = await this.editApply(selection.map(item => item.id), reviewStatus).catch(_ => {})
      if (result) {
        selection.forEach(row => {
          row.reviewStatus = reviewStatus
          this.$refs.table.toggleRowSelection(row, false)
        })
        this.fetchData()
      }
    },

    async handleBatchReview(reviewStatus) {
      const { selection } = this
      if (selection.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请选择至少一条流水'
        })
      }

      if (reviewStatus === 3) { // 拒绝需要填写原因
        this.$prompt('请输入拒绝原因：', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.+/,
          inputErrorMessage: '原因不能为空'
        }).then(async({ value }) => {
          const result = await this.reviewApply(selection.map(item => item.id), reviewStatus, value).catch(_ => {})
          if (result) {
            selection.forEach(row => {
              row.reviewStatus = reviewStatus
              this.$refs.table.toggleRowSelection(row, false)
            })
            this.fetchData()
          }
        }).catch(() => {})
      } else {
        const result = await this.reviewApply(selection.map(item => item.id), reviewStatus).catch(_ => {})
        if (result) {
          selection.forEach(row => {
            row.reviewStatus = reviewStatus
            this.$refs.table.toggleRowSelection(row, false)
          })
          this.fetchData()
        }
      }
    },

    async handleTrans(row) {
      this.transfer([row.id], 3)
    },

    async handleEditApply(row, reviewStatus) {
      const result = await this.editApply([row.id], reviewStatus).catch(_ => {})
      if (result) {
        row.reviewStatus = reviewStatus
        this.$refs.table.toggleRowSelection(row, false)
        this.fetchData()
      }
    },

    async handleReview(row, reviewStatus) {
      if (reviewStatus === 3) { // 拒绝需要填写原因
        this.$prompt('请输入拒绝原因：', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.+/,
          inputErrorMessage: '原因不能为空'
        }).then(async({ value }) => {
          const result = await this.reviewApply([row.id], reviewStatus, value).catch(_ => {})
          if (result) {
            row.reviewStatus = reviewStatus
            this.$refs.table.toggleRowSelection(row, false)
            this.fetchData()
          }
        }).catch(() => {})
      } else {
        let apply = 'confirm'
        if (row.cpStatus === -1) {
          try {
            apply = await this.$confirm('当前歌曲版权状态是唱片公司确认无版权，确认修改版权信息吗?', '提示', {
              type: 'warning'
            })
          } catch (error) {
            apply = false
          }
        }

        if (apply) {
          const result = await this.reviewApply([row.id], reviewStatus).catch(_ => {})
          if (result) {
            row.reviewStatus = reviewStatus
            this.$refs.table.toggleRowSelection(row, false)
            this.fetchData()
          }
        }
      }
    },

    async editApply(idList, reviewStatus) {
      const postData = {
        idList,
        reviewStatus
      }
      this.searching = true
      try {
        await albumService.reviewEditAlbumReview(postData)
        return Promise.resolve(true)
      } catch (error) {
        this.$message({
          type: 'error',
          message: `提交异常(${error.message})`,
          error
        })
        return Promise.reject(false)
      } finally {
        this.searching = false
      }
    },

    async reviewApply(idList, reviewStatus, rejectReason = '') {
      const postData = {
        idList,
        reviewStatus,
        rejectReason
      }
      this.searching = true
      try {
        await albumService.reviewModifyAlbum(postData)
        return Promise.resolve(true)
      } catch (error) {
        this.$message({
          type: 'error',
          message: `提交异常(${error.message})`,
          error
        })
        return Promise.reject(false)
      } finally {
        this.searching = false
      }
    },
    async transfer(idList, roleType) {
      const postData = {
        idList,
        roleType
      }
      this.searching = true
      try {
        await albumService.transAlbumReviewType(postData)
        this.fetchData()
      } catch (error) {
        this.$message({
          type: 'error',
          message: `转换异常(${error.message})`,
          error
        })
      }
      this.searching = false
    },
  }
}
</script>

<style scoped lang="scss">
.form-comp {
  width: 200px;
}
</style>
